if not App.angularApp?
    return

###
    This directive allows clicking a different element to trigger a
    click event in the given input[file] element.It then calls the given
    callback function. Files are passed to the function.

    ------------ HTML

    <input type="file" id="fileinputid"/>
    <button
        mf-click-input-file="#fileinputid"
        mf-click-input-file-handler="controllerFunctionUpload"
    >
        Upload
    </button>

    ------------- ANGULARJS CONTROLLER

    controllerFunctionUpload: (files) =>
        ...
###
App.angularApp.directive 'mfClickInputFile', () ->
    return {
        restrict: 'A'
        scope:
            handler: '&mfClickInputFileHandler'
        link: (scope, element, attrs) ->
            input = attrs.mfClickInputFile
            handler = scope.handler()

            # Trigger click of file input when this element is clicked
            element.bind 'click', (e) =>
                angular.element(input).trigger('click')

            # Watch input for change and trigger handler
            angular.element(input).bind 'change', (e) =>
                handler e.target.files
                # Reset file input so we can upload again
                angular.element(input).val('')
    }
